import React from "react";
import { Input } from "antd";
import "./style.scss";

export default function CustomInput({ label, placeholder, ...rest }) {
  return (
    <div className="custom-input-container mb-1">
      <div>
        <p>{label}</p>
        <Input placeholder={placeholder} variant="borderless" {...rest} />
      </div>
    </div>
  );
}
